module.exports = __webpack_public_path__ + "img/bling_logo.f4c9eecb.png";